import React, { useState } from "react";
import Form from "./form.jsx";
import ThankYou from "./thank-you.jsx";

export default function SaveSearch(props) {

    const [{ isSaved, name }, setIsSaved] = useState({ isSaved: false });

    return (
        <div className="d-flex flex-column h-100 align-items-center justify-content-center save-search-popup-body">
            {isSaved ? <ThankYou {...props} name={name} /> : <Form {...props} onSaved={(e) => setIsSaved({ isSaved: true, name: e.name })} />}
        </div>
    );

}